import { Navigate, Outlet } from "react-router-dom";

const PrivateComponent=()=>{
    const auth= localStorage.getItem('user');
    return auth?<Outlet/>:<Navigate to="/features"/>
}

export default PrivateComponent;